import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelContent,
} from '@angular/material/expansion';
import { NgScrollbar } from 'ngx-scrollbar';
import { NgClass, AsyncPipe } from '@angular/common';
import { getSpendLineItemSummary } from '../../store/spend/spend.selectors';
import { AppState } from '../../store/app-state';
import { spendActionTypes } from '../../store/spend/spend.actions';
import { MoneyPipe } from '../../pipes/framework/money-short.pipe';
import { ArrowButtonBoxComponent } from '../dropdown-button-box/arrow-button-box.component';
import { LoadingSpinnerComponent } from '../loading-animation/loading-spinner.component';

@Component({
  selector: 'app-line-item-spend-summary',
  templateUrl: './line-item-spend-summary.component.html',
  styleUrls: ['./line-item-spend-summary.component.scss'],
  imports: [
    NgScrollbar,
    NgClass,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    ArrowButtonBoxComponent,
    MatExpansionPanelContent,
    LoadingSpinnerComponent,
    AsyncPipe,
    MoneyPipe,
  ],
})
export class LineItemSpendSummaryComponent implements OnDestroy {
  spendLineItemSummary$ = this.store.select(getSpendLineItemSummary);
  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnDestroy() {
    this.store.dispatch(spendActionTypes.clearSpendLineItemSummary());
  }

  /**
   * Toggle expansion panel
   * First a close/open has to be called to set the state of the panel
   * Then a toggle has to be called to trigger the animation
   * @param panel - panel to be toggled
   */
  onExpansionPanelClick(panel: MatExpansionPanel) {
    panel.expanded ? panel.close() : panel.open();
    panel.toggle();
  }
}
